import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography, Link as MuiLink } from "@mui/material";
import Footer from "../Components/Footer/Footer";

const sectionSx = { mt: 4 };
const bodySx = { lineHeight: 1.8, mb: 1.5 };

const TermsOfService = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Use | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Terms of use for the Đông Hưng Viên Bakery website."
        />
      </Helmet>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          background: "#fff",
          pt: { xs: 14, md: 18 },
          pb: 8,
        }}
      >
        <Box sx={{ maxWidth: "860px", width: "90%", color: "#222" }}>
          <Typography variant="h3" sx={{ fontSize: { xs: "28px", md: "36px" }, fontWeight: 700, mb: 1 }}>
            Terms of Use
          </Typography>
          <Typography sx={{ color: "#666", mb: 3 }}>Effective date: August 4, 2026</Typography>

          <Typography sx={bodySx}>
            These Terms of Use govern your use of the donghungvienbakery.com website (the “Site”),
            operated by Đông Hưng Viên Bakery (Dong Hung Vien, Inc.), located at 8536 Westminster
            Blvd, Westminster, CA 92683. By using the Site, you agree to these terms.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>Site Content</Typography>
          <Typography sx={bodySx}>
            All text, photos, logos, and menu descriptions on the Site are the property of Đông Hưng
            Viên Bakery or its licensors and may not be copied or reused without our permission.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>Menu, Pricing &amp; Availability</Typography>
          <Typography sx={bodySx}>
            Menu items, prices, ingredients, and availability shown on the Site are provided for
            general reference and are subject to change without notice. Please confirm current
            pricing, availability, and ingredient/allergen information with our staff in person, by
            phone, or at the time of ordering.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>Allergen Notice</Typography>
          <Typography sx={bodySx}>
            Our kitchen prepares food that may contain or come into contact with wheat/gluten, eggs,
            dairy, soy, peanuts, tree nuts, and shellfish. Item descriptions on the Site are not a
            substitute for asking our staff about ingredients if you have a food allergy or dietary
            restriction.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>Third-Party Ordering</Typography>
          <Typography sx={bodySx}>
            Online orders placed through the “Order Now” button are processed on Toast, Inc.'s
            ordering platform, which has its own terms of service and privacy policy. We are not
            responsible for the availability or performance of that third-party platform.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>No Warranty; Limitation of Liability</Typography>
          <Typography sx={bodySx}>
            The Site is provided “as is” without warranties of any kind. To the fullest extent
            permitted by law, Đông Hưng Viên Bakery is not liable for any indirect or consequential
            damages arising from your use of the Site.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>Governing Law</Typography>
          <Typography sx={bodySx}>
            These terms are governed by the laws of the State of California, without regard to
            conflict-of-law principles, and any dispute shall be resolved in the state or federal
            courts located in Orange County, California.
          </Typography>

          <Typography variant="h5" sx={sectionSx}>Contact Us</Typography>
          <Typography sx={bodySx}>
            Đông Hưng Viên Bakery (Dong Hung Vien, Inc.)
            <br />
            8536 Westminster Blvd, Westminster, CA 92683
            <br />
            Phone: <MuiLink href="tel:7148914404">(714) 891-4404</MuiLink>
            <br />
            Email:{" "}
            <MuiLink href="mailto:info@donghungvienbakery.com">info@donghungvienbakery.com</MuiLink>
          </Typography>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default TermsOfService;
